module.exports = __webpack_public_path__ + "static/img/logo.4788abb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo.png
// module id = Pl8J
// module chunks = 11